var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Carousel'),_c('Aboutmetro'),_c('Activities'),_c('MainPageGallery'),_c('Slider'),_c('Featured'),_c('Association'),_c('Testimonial'),_c('Form'),_c('Sponsors'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }